import SimpleAbility from './simpleAbility'
import { initialAbility } from './config'

export default new SimpleAbility(initialAbility)
